import React from 'react'
import tw from 'tailwind-styled-components'
import IconDelete from '../../common/icons/icons-common/icon-delete.svg'
import IconEdit from '../../common/icons/icons-common/icon-edit.svg'

const TwIcon = tw.div`
  text-third-old
  hover:text-action-hover
  active:text-action-pressed
  cursor-pointer
  flex
  items-center
  pt-1
`

type Props = {
  edit: () => void
  del: () => void
}

export const StringStateActions = ({edit, del}: Props) => {
  return (
    <div className="flex gap-18 ml-18">
      <TwIcon onClick={edit}>
        <IconEdit />
      </TwIcon>
      <TwIcon onClick={del}>
        <IconDelete />
      </TwIcon>
    </div>
  )
}
